/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Step Three View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './stepThreeView';

export const mapStateToPropsStepThree = mapStateToProps;
export const mapDispatchToPropsStepThree = mapDispatchToProps;

export default connect(
  mapStateToPropsStepThree,
  mapDispatchToPropsStepThree
)(View);
